import React from 'react';
import './styles/Header.css';

export const Header = ({
  children,
  sticky = true,
  transparent = false,
  className = '',
  ...props
}) => {
  const classes = `header ${sticky ? 'header-sticky' : ''} ${transparent ? 'header-transparent' : ''} ${className}`;
  
  return <header className={classes} {...props}>{children}</header>;
};

export const Nav = ({ children, className = '', ...props }) => (
  <nav className={`nav ${className}`} {...props}>{children}</nav>
);

export const NavItem = ({ children, active = false, className = '', ...props }) => (
  <a className={`nav-item ${active ? 'nav-item-active' : ''} ${className}`} {...props}>
    {children}
  </a>
);

export const NavBrand = ({ children, className = '', ...props }) => (
  <div className={`nav-brand ${className}`} {...props}>{children}</div>
);

export default Header;
